/**
 * A faixa do regulador (`OB-13`, ADR-075): quem lê o cockpit como poder concedente sabe, o
 * tempo todo, que o acesso é só de leitura e que a concessionária vê o que ele consultou.
 * Não se fecha — é a regra do acesso, e não um aviso de passagem.
 */
import { Badge } from "./base";

export function FaixaDoRegulador() {
  return (
    <div
      role="note"
      aria-label="Acesso do poder concedente"
      className="flex flex-wrap items-center gap-2 rounded-cartao border border-azul-borda bg-azul-fundo px-3 py-2 text-[12px] text-tinta-2"
    >
      <Badge cor="azul">Poder concedente</Badge>
      <span>
        Acesso só de leitura. Cada tela que você abre fica registrada, e a
        concessionária vê o que foi consultado.
      </span>
    </div>
  );
}
